<template>
  <Bar
    :chart-options="chartOptions"
    :chart-data="chartData"
    :chart-id="chartId"
    :dataset-id-key="datasetIdKey"
    :width="width"
    :height="height"
  />
</template>

<script>
import { Bar } from 'vue-chartjs/legacy';
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  BarElement,
  CategoryScale,
  LinearScale,
} from 'chart.js';

ChartJS.register(
  Title,
  Tooltip,
  BarElement,
  CategoryScale,
  LinearScale
);

export default {
  name: 'ConfidenceDistribution',
  components: { Bar },
  props: {
    data: {
      type: Array,
      required: true,
    },
    remainingScreeningCount: {
      type: Number,
      required: true,
    },
    chartId: {
      type: String,
      default: 'confidence-distribution-chart',
    },
    datasetIdKey: {
      type: String,
      default: 'label',
    },
    width: {
      type: Number,
      default: 250,
    },
    height: {
      type: Number,
      default: 82,
    },
  },
  data() {
    return {
      chartOptions: {
        datasets: {
          bar: {
            backgroundColor: [
              '#ef5050',
              '#ef5050',
              '#ef5050',
              '#ef5050',
              '#ef5050',
              '#ffa552',
              '#ffa552',
              '#ffa552',
              '#ffa552',
              '#19aa55',
            ],
          },
        },
        plugins: {
          legend: {
            display: false,
          },
          tooltip: {
            intersect: false,
            position: 'nearest',
            callbacks: {
              title: (tooltipItems) => {
                const item = tooltipItems[0];
                const confidence = parseFloat(item.label);
                if (confidence >= 0.9) {
                  return 'Likely Relevant';
                } else if (confidence >= 0.5) {
                  return 'Potentially Relevant';
                } else {
                  return 'Likely Not Relevant';
                }
              },
              label: (context) => {
                const count = this.counts[context.parsed.y];
                const pct = context.parsed.y.toFixed(2);
                return ` ${count} (${pct}%)`;
              },
            },
          },
        },
        scales: {
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
          },
          y: {
            display: false,
            suggestedMin: 0,
            suggestedMax: 100,
          },
        },
      },
    };
  },
  computed: {
    y() {
      return this.data.map((value) => value * 100);
    },
    chartData() {
      return {
        labels: [0.0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9],
        datasets: [
          {
            data: this.y,
          },
        ],
      };
    },
    counts() {
      return this.y.reduce((map, value) => {
        map[value] = Math.ceil(
          (value / 100) * this.remainingScreeningCount
        );
        return map;
      }, {});
    },
  },
};
</script>
